import { all, call, put, takeLatest } from "redux-saga/effects";
import * as actions from "../slices/contentSlice";

import contentApis from "src/api/content";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// get patient details saga
const GetContentSaga = function* GetContentSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      contentApis.getContent,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getContentSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getContentError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

const GetContentListSaga = function* GetContentListSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      contentApis.getContentList,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    //yield put(getContentListSuccess({ data: response.data, page: action.payload.payload.page }));

    yield put(
      actions.getContentListSuccess({
        data: response?.data,
        page: payload.page,
      })
    );
    resolve(response);
  } catch (error) {
    yield put(
      actions.getContentListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// get patient details saga
const GetTopicsSaga = function* GetTopicsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      contentApis.getTopics,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getTopicsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getTopicsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* contentSaga() {
  yield all([
    takeLatest(actions.getContentRequest, GetContentSaga),
    takeLatest(actions.getContentListRequest, GetContentListSaga),
    takeLatest(actions.getTopicsRequest, GetTopicsSaga),
  ]);
}
